import { FC } from 'react';
import { createPortal } from 'react-dom';

import classNames from 'classnames';
import { Box } from '@components/layout/Box';
import { Body } from '@components/text';

import './LoadingOverlay.scss';
interface LoadingOverlayProps {
  text?: string;
  isVisible?: boolean;
  containerRef?: HTMLElement | null;
}

/**
 * LoadingOverlay component
 * @param text - The text shown under the spinner. (optional).
 * @param isVisible - Whether to show the loading overlay. Default is false.
 * @param containerRef - Optional ref to the container where the loading overlay will be rendered. Default is document.body.
 */
export const LoadingOverlay: FC<LoadingOverlayProps> = ({
  text = '',
  isVisible = false,
  containerRef,
}) => {
  if (!isVisible) {
    return null;
  }

  return createPortal(
    <Box
      overlayOpacity="opacity-dim"
      className={classNames('vds-loading-overlay__wrapper', {
        'vds-loading-overlay__wrapper--fixed-position': !containerRef,
      })}
      aria-live="polite"
      aria-busy="true">
      <div className="vds-loading-overlay__animation" role="status">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 200 200"
          className="vds-loading-overlay__svg">
          <g fill="currentColor">
            <path d="M8.16,138.48A99.6,99.6,0,0,0,49,185.78l5.8-14.07a84.94,84.94,0,0,1-.27-143.23l-5.83-14A100.06,100.06,0,0,0,8.16,138.48Z"></path>
            <path d="M199.54,85.9A100.13,100.13,0,0,0,76.29,3l5.83,14A85,85,0,0,1,184.38,85.9Z"></path>
            <path d="M138.94,192.39a100,100,0,0,0,60.34-76.6H184.07A84.86,84.86,0,0,1,82.43,183.1l-5.8,14.07A99.6,99.6,0,0,0,138.94,192.39Z"></path>
          </g>
        </svg>
      </div>
      {text && <Body className="vds-loading-overlay__text">{text}</Body>}
    </Box>,
    containerRef || document.querySelector('.vds-theme-wrapper') || document.body,
  );
};
